import APIService from '@/services/APIService.js';

export default {
    getAll() {
      return APIService.apiCall().get('/taxa-wacc/get-all');
    }
  };